import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { isTenantUser } from '../../lib/authRoles';
import { RouteAuthSpinner } from './RouteAuthSpinner';

/** Tenant portal routes — owners/managers are redirected away. */
export function TenantOnlyRoute({ children }) {
  const { user, loading } = useAuth();
  if (loading) return <RouteAuthSpinner />;
  if (!isTenantUser(user)) {
    return <Navigate to="/app/dashboard" replace />;
  }
  return children;
}
